<template>
<section class="Section NoTopPadding">
	<div class="Container">		
		<div class="BoxWide">
			<div class="BookingPanel">
				<booking-navigator></booking-navigator>
				<div class="BookingContent">
					<div class="BookingMap">
						<DxMap
						:api-key="keys"
						:zoom="9"
						:height="480"
						:controls="true"
						:markers="markersData"
						v-model:type="mapTypeValue"
						center="43.7689783,11.262686"
						width="100%"
						provider="google"						
						/>
						<DxToast
							v-model:visible="isToastVisible"
							message="Attenzione, per proseguire è necessario selezionare un centro medico."
							type="error"
							:height="60"
							:width="500"
							:displayTime= "3000"
							position="center"							
						>
						
						</DxToast>
					</div>
				</div>
				<div class="BookingContent">
					<booking-address></booking-address>
					<booking-description></booking-description> 
					<div class="Button TwinButton">	
						<router-link to="/BookingCalendar" tag="a">Scegli questo centro</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
</template>
<script>

import BookingNavigator from '@/components/BookingNavigator.vue'
import BookingAddress from '@/components/BookingAddress.vue'
import BookingDescription from '@/components/BookingDescription.vue'
import DxMap from 'devextreme-vue/map';
import { DxToast } from 'devextreme-vue/toast';
import WebApiService from "@/services/webapi.service.js";


export default ({
    name: 'BookingPanelMap',
		data(){
		return {
			keys: {        
				google: "AIzaSyAWC3KKrhGnGDSLd5YzBp0eIUWBmOHVkTw"        
			},
			mapTypeValue: "roadmap",
			showControls: true,		
		markersData : [],
		isToastVisible: false
		}	  
    }, 
	
    methods:{
		
		SetMarkers(markers){			
			this.$store.commit("setMarkers", markers);
		},			

		MarkerClick(centro) {	
			if(this.$store.getters.getCentro?.IdCentro != centro.centro["IdCentro"]){			
				this.$store.commit('setGiorno', "");
				this.$store.commit('setIdOrario', "");
				this.$store.commit('setOrario', "");
			}	
			let centroStore = {
				IdCentro : centro.centro["IdCentro"],
				Citta : centro.centro["Citta"],
				Provincia : centro.centro["Provincia"],
				Note : centro.centro["Note"],
				Indirizzo : centro.centro["Indirizzo"],
				Descrizione : centro.centro["Descrizione"],
				DescrizioneEn : centro.centro["DescrizioneEn"],
				DescrizioneEstesa : centro.centro["DescrizioneEstesa"],
				DescrizioneEstesaEn : centro.centro["DescrizioneEstesaEn"],
				Orario : centro.centro["Orario"],
				OrarioEn : centro.centro["OrarioEn"],
				Email : centro.centro["Email"],
				Latitudine : centro.centro["Latitudine"],
				Longitudine : centro.centro["Longitudine"],
				Telefono : centro.centro["Telefono"],
			};			
			this.$store.commit('setCentro', centroStore);
		}	
    },
	components:{
		BookingNavigator,
		BookingAddress,
		BookingDescription,
		DxMap,
		DxToast
	},
	mounted(){	
		
		let markers = this.$store.getters.getMarkers;		
		markers.forEach((item,) => {		
			item.onClick = () => {					
				this.MarkerClick(item);
			}
		});
		this.markersData = markers;
		
	},  
    beforeRouteLeave(to, from, next){		
		if(!this.$store.getters.getCentro?.IdCentro){		
			this.isToastVisible = true;
		}
		else{
			next();
		}
    },
	beforeRouteEnter (to, from, next) {      
		var markers = [];
		WebApiService.get('CentroMedico/GetCentriMedici', {}).then(
            (data) => { 				
                if(data.StatusCode !== 200){                  
					console.log(data.Message)
                }
                else{
					debugger;						
					data.Data.forEach((item) => {
						let marker = {
							location: [item.Latitudine, item.Longitudine],							
							tooltip: {
									text: item.Descrizione + "<br />" + item.Indirizzo + " " + item.Citta + "(" + item.Provincia + ")"
								},
							centro: item
						}					
						markers.push(marker);						
					});
					next(c => c.SetMarkers(markers));                         
                }
            },
            error => {
				console.log(error);
				next();
            }
            )
            .catch(              
                error => {
					console.log(error);
					next();
				}
				
            );
        
    }
})

</script>




